export const justifySpaceBetween = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const justifyAlignCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const justifyAlignEnd = {
  display: "flex",
  justifyContent: "end",
  alignItems: "flex-end",
};

export const dividerMargin = { mt: "20px", mb: "20px" };

export const spinnerColor = { color: "#DB154D" };

export const width = { width: "100%" };

export const ellipseHiddenText = {
  color: "#212121",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

export const listingPaper = {
  borderRadius: "8px",
  height: "100%",
  p: "0 0 32px",
};
